import { render } from "./subscriptionAlert.vue?vue&type=template&id=49f36d0d&scoped=true"
import script from "./subscriptionAlert.vue?vue&type=script&lang=js"
export * from "./subscriptionAlert.vue?vue&type=script&lang=js"

import "./subscriptionAlert.vue?vue&type=style&index=0&id=49f36d0d&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f36d0d"]])

export default __exports__